import { makeAutoObservable } from "mobx";

type TranslationData = { [key: string]: any };
type GlobalError = { key: string; data?: TranslationData; allowClosing?: boolean };

export class GlobalErrorsStore {
  private _errors: GlobalError[] = [];
  private _errorContainerHeight: string = "0px";

  constructor() {
    makeAutoObservable(this);
  }

  public get hasErrors(): boolean {
    return this._errors.length > 0;
  }

  public hasSpecificErrors(errorKeys: string[]): boolean {
    return this._errors.some(error => errorKeys.includes(error.key));
  }

  public get currentErrors(): GlobalError[] {
    return this._errors;
  }

  public get errorContainerHeight(): string {
    return this._errorContainerHeight;
  }

  public setErrorContainerHeight(height: string): void {
    this._errorContainerHeight = height;
  }

  public addErrorIfNotExists(key: string, data?: TranslationData, allowClosing = false): void {
    if (!this._errors.find(error => error.key === key && error.data == data)) {
      this._errors.push({ key, data, allowClosing: !!allowClosing });
    }
  }

  public addOrOverrideError(key: string, data?: TranslationData): void {
    console.log(key, data);

    const existingError = this._errors.find(e => e.key === key);
    if (existingError) {
      existingError.data = data;
      return;
    }

    this._errors.push({ key, data });
  }

  public removeError(key: string): void {
    const reducedErrors = this._errors.filter(e => e.key !== key);

    if (reducedErrors.length != this._errors.length) {
      this._errors = reducedErrors;
    }
  }

  public clearErrors(): void {
    if (this._errors.length) {
      this._errors = [];
    }
  }
}
